import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Subject } from "rxjs/Subject";
import 'rxjs/add/operator/map';
import { timeout } from "rxjs/operator/timeout";


@Injectable()
export class ToppostsService {
    http: Http;

    topArticlesDataChange = new Subject<void>();
    topArticles = [];
    private topArticlesData = [];


    constructor(http: Http) {
        this.http = http;
    }

    fetchTopArticles(media) {
        this.http.get(`/api/top-articles/${media}`)
            .map((response: Response) => {
                const data = response.json();
                this.topArticles = [
                    [
                        {
                            "topshort": data.acticlesShort,
                            "topmid": data.acticlesMid,
                            "toptoday": data.acticlesToday,
                            "active": data.active
                        }
                    ]
                ];
                return this.topArticles;
            })
            .subscribe(
            (data) => {
                this.topArticlesData = data;
                setTimeout(() => this.topArticlesDataChange.next(), 1000 * 12);
            }
            );
    }
    fetchTopPosts() {
        // console.log(this.topArticlesData[0]);
        return this.topArticlesData[0];
    }

}


// WEBPACK FOOTER //
// /home/node/src/app/_services/topposts.service.ts